;(function (global, factory) {
    typeof define === 'function' && define.amd ? define('score_bootstrap/Components/VimeoVideo',["jquery", "eventManager", 'loglevel', "//player.vimeo.com/api/player.js"], factory) :
    typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("jquery"), require("eventManager"), require('loglevel'), require("//player.vimeo.com/api/player.js")) :
    console && console.error('Vimeo does not support non-amd script loading.');
}(this/* window */, function ($, eventManager, log, vimeoPlayer) {

    function VimeoVideo(scope, stateChangeMessages, onPlayMessagesPerformer, onPauseMessagePerformer) {
        ///<summary>Initialize a new instance of YoutubeVideo. Subscribe to messages which are passed to current instance.</summary>

        var self = this, instance = {};
        instance.stateChangeMessages = stateChangeMessages.slice();
        
        Object.defineProperties(this, {
            scope: { enumerable:!1, value: scope },
            $scope: { enumerable: true, value: $(scope) },
            stateChangeMessages: {
                enumerable: true,
                get: function () {
                    return instance.stateChangeMessages.slice();
                }
            },
            trackTimelineInterval: {
                enumerable: !1,
                value: void 0,
                writable: !0,
            },
            currentTime: {
                enumerable: !1,
                value: void 0,
                writable: !0
            },
            isInteractedWithUser: { enumerable: true, configurable: true, writable: true, value: false }
        });
        
        this.addStateChangeMessage = function addStateChangeMessage(message) {
            if (!message) return;
            if (instance.stateChangeMessages.indexOf(message) > -1) {
                log.debug("Component is already registered for event " + message);
                return;
            }
            
            instance.stateChangeMessages.push(String(message));
        };

        //#region play message performer
        if (onPlayMessagesPerformer.length) {
            onPlayMessagesPerformer.forEach(function (messageName) {
                eventManager.subscribe(messageName, self.play, self);
            });
        }
        //#endregion

        //#region show messages performer
        if (onPauseMessagePerformer.length) {
            onPauseMessagePerformer.forEach(function (messageName) {
                eventManager.subscribe(messageName, self.pause, self);
            });
        }
        //#endregion

        if (this.stateChangeMessages.length) {
            this.stateChangeMessages.forEach(function (ev) {
                eventManager.trigger(ev, self);
            });
        }
        
        var player = new vimeoPlayer(this.$scope.find('iframe'));
        player.ready().then(function() {
            var videoId = self.$scope.find('iframe').attr('id');

            Object.defineProperties(self,
                {
                    videoId: { enumerable: true, value: videoId },
                    player: { enumerable: false, value: player }
                });
        });

        player.on('play', this._onPlayHandler.bind(this));
        //player.on('pause.score', this._onPauseHandler.bind(this));
        player.on('ended', this._onEndedHandler.bind(this));
    }

    VimeoVideo.prototype._onPlayHandler = function (data) {
        this.currentTime = Math.floor(data.seconds);
        this.isInteractedWithUser = true;

        if (data.seconds === 0) {
            $(this).trigger('start.video', [this.currentTime]);
        }

        $(this).trigger('update.timeline', [this.currentTime]);
        this.startTrackTimeline();
    }

    VimeoVideo.prototype._onPauseHandler = function (data) {
        this.stopTrackTimeline();

        log.debug('vimeo video paused');
        var oldValue = this.currentTime;
        this.currentTime = Math.floor(data.seconds);
        this.isInteractedWithUser = true;
        if (oldValue !== this.currentTime) {
            $(this).trigger('update.timeline', [this.currentTime]);
        }

        $(this).trigger('pause.video', [this.currentTime]);
    }

    VimeoVideo.prototype._onEndedHandler = function (data) {
        this.stopTrackTimeline();

        this.currentTime = Math.floor(data.seconds);
        this.isInteractedWithUser = true;
        $(this).trigger('end.video', [this.currentTime]);
    }

    VimeoVideo.prototype.startTrackTimeline = function () {
        if (this.trackTimelineInterval) {
            clearInterval(this.trackTimelineInterval);
        }

        this.trackTimelineInterval = setInterval((function () {
            this.player.getCurrentTime().then((function(seconds) {
                this.currentTime = Math.floor(seconds);
                $(this).trigger('update.timeline', [this.currentTime]);
            }).bind(this));
        }).bind(this), 1000 /* 1 second */);

        $(this).trigger('update.timeline', [this.currentTime]);

        // some vimeo video keep sending "pause" event all the time while pause. That's why we assign a handler when start tracking and remove it when player stopped.
        this.player.on('pause', this._onPauseHandler.bind(this));
    }

    VimeoVideo.prototype.stopTrackTimeline = function () {
        if (this.trackTimelineInterval) {
            clearInterval(this.trackTimelineInterval);
        }

        // some vimeo video keep sending "pause" event all the time while pause.
        this.player.off('pause');
    }

    VimeoVideo.prototype.play = function () {
        ///<summary>Start playing the video.</summary>
        var player = new vimeoPlayer(this.$scope.find('iframe'));

        // On certain mobile devices, including those running iOS, and in certain desktop browsers like Chrome and Safari, 
        // you can't programmatically trigger the initial playback of a video.
        // https://developer.vimeo.com/player/sdk/reference#play-a-video
        // We can play embedded media via API in muted state only or when user has already interacted with the player.
        if (!this.isInteractedWithUser) {
            player.setVolume(0);
        }

        player.play().then((function() {
            this.transmitStateChange();
        }).bind(this)).catch(function (error) {
            switch (error.name) {
                case 'PasswordError':
                    // the video is password-protected and the viewer needs to enter the
                    // password first
                    break;

                case 'PrivacyError':
                    // the video is private
                    break;

                case 'NotAllowedError':
                    log.error(error.message);
                    break;

                default:
                    break;
            }
        });

    }

    VimeoVideo.prototype.pause = function () {
        ///<summary>Put the video on pause.</summary>

        var player = new vimeoPlayer(this.$scope.find('iframe'));

        player.pause().then((function () {
            this.transmitStateChange();
        }).bind(this)).catch(function (error) {
            switch (error.name) {
            case 'PasswordError':
                // the video is password-protected and the viewer needs to enter the
                // password first
                break;

            case 'PrivacyError':
                // the video is private
                break;

            default:
                // some other error occurred
                break;
            }
        });
    }

    VimeoVideo.prototype.transmitStateChange = function () {
        var messages = this.stateChangeMessages, self = this;
        if (messages.length) {
            messages.forEach(function (ev) {
                eventManager.trigger(ev, self, self.player);
            });
        }

    }
    // #endregion

    VimeoVideo.init = function init(args) {
        if (args.IsEditorEditing) return null;

        var video = new VimeoVideo(args.scope,
            args.StateChangeMessagesTransmitting || [],
            args.PlayActionMessages || [],
            args.PauseActionMessages || []);

        return video;
    };

    return VimeoVideo;
}));
